import { post } from '../utils/request';

export const getFarthestColorApi = function (request) {
  return post(`/api/v1/Colorize/GetFarthestColor?colorReference=${request.colorReference}`, request.colorList);
};
